import React from "react";
import { AgGridReact } from "ag-grid-react";
import { useMemo, useCallback, useRef } from "react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-community/dist/styles/ag-theme-balham-dark.css";


const CustomLoadingOverlay = (props) => {
    return (
      <div
        className="ag-overlay-loading-center"
        style={{ height: '9%' }}
      >
        
      </div>
    );
  };
  const CustomNoRowsOverlay = (props) => {
    return (
      <div
        className="ag-overlay-loading-center"
        style={{ height: '9%'}}
      >
        {/* <ThreeCircles
            height="100"
            width="100"
            color="#4fa94d"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel="three-circles-rotating"
            outerCircleColor="var(--theme1_primary)"
            innerCircleColor="var(--theme1_secondary)"
            middleCircleColor="var(--theme1_tertiary)"
          /> */}
          {props.loadingMessage}
      </div>
    );
  };

/**
 * This is a default grid component for all reports. Please do not change the settings unless customization is required.
 * @param {*} props 
 * @returns 
 */
export const IntegrationReportGrid = (props) => {
  // const gridRef = useRef(props.gridRef);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
  
  const onFirstDataRendered = useCallback((params) => {
    // gridRef.current.api.sizeColumnsToFit();
    // // Get all the column IDs
    // const allColumnIds = params.columnApi.getAllColumns().map(col => col.getId());
    
    // // Auto-size the columns
    // params.columnApi.autoSizeColumns(allColumnIds);
  }, []);
  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      filter: true,
      resizable: true,
      animateRows: true,
    }),
    []
  );

  const loadingOverlayComponent = useMemo(() => {
    return CustomLoadingOverlay;
  }, []);
  const loadingOverlayComponentParams = useMemo(() => {
    return {
      loadingMessage: props.loadingOverlay,
    };
  }, []);
  const noRowsOverlayComponent = useMemo(() => {
    return CustomNoRowsOverlay;
  }, []);
  const noRowsOverlayComponentParams = useMemo(() => {
    return {
    loadingMessage: props.rowOverlay,

    };
  }, []);

 

  return (
    <div className="ag-theme-balham" style={gridStyle}>
      <AgGridReact
        ref={props.gridRef}
        rowData={props.rowData}
        columnDefs={props.colDefs}
        defaultColDef={defaultColDef}
        onGridReady={props.onGridReady}
        alwaysShowHorizontalScroll={false}
        alwaysShowVerticalScroll={false}
        sideBar={"columns"}
        onFirstDataRendered={onFirstDataRendered}
        pagination={true}
        loadingOverlayComponent={loadingOverlayComponent}
        loadingOverlayComponentParams={loadingOverlayComponentParams}
        noRowsOverlayComponent={noRowsOverlayComponent}
        noRowsOverlayComponentParams={noRowsOverlayComponentParams}
        rowSelection={"multiple"}
        onSelectionChanged={props.onSelectionChanged}
        isExternalFilterPresent={() => true}
        doesExternalFilterPass={props.isRowVisible}
        suppressRowClickSelection={true}
      />
    </div>
  );
};

export const ReportModalGrid = (props) => {
  console.log("REPORT MODAL GRID PROPS: ", props)
  const gridRef = useRef();
  const gridStyle = useMemo(() => ({ height: "89.3vh", width: "100%" }), []);
  const onFirstDataRendered = useCallback((params) => {
    // Get all the column IDs
    const allColumnIds = params.columnApi.getAllColumns().map(col => col.getId());
    
    // Auto-size the columns
    params.columnApi.autoSizeColumns(allColumnIds);
  }, []);
  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      filter: true,
      resizable: true,
      animateRows: true,
    }),
    []
  );

  const loadingOverlayComponent = useMemo(() => {
    return CustomLoadingOverlay;
  }, []);
  const loadingOverlayComponentParams = useMemo(() => {
    return {
      loadingMessage: props.loadingOverlay,
    };
  }, []);
  const noRowsOverlayComponent = useMemo(() => {
    return CustomNoRowsOverlay;
  }, []);
  const noRowsOverlayComponentParams = useMemo(() => {
    return {
    loadingMessage: props.rowOverlay,

    };
  }, []);

  return ( 
    <div className="ag-theme-balham" style={gridStyle}>
      <p className="report-modal-grid-message" >*Note: Retry only works if data is incorrect in the data consuming vendor (assuming you have fixed it). 
        If data was incorrectly uploaded in excel, please upload it again with correct data.</p>
      <AgGridReact
        ref={gridRef}
        rowData={props.rowData}
        columnDefs={props.colDefs}
        defaultColDef={defaultColDef}
        onGridReady={props.onGridReady}
        alwaysShowHorizontalScroll={false}
        alwaysShowVerticalScroll={false}
        sideBar={"columns"}
        rowSelection={'multiple'}
        rowMultiSelectWithClick={true}
        onFirstDataRendered={onFirstDataRendered}
        pagination={true}
        loadingOverlayComponent={loadingOverlayComponent}
        loadingOverlayComponentParams={loadingOverlayComponentParams}
        noRowsOverlayComponent={noRowsOverlayComponent}
        noRowsOverlayComponentParams={noRowsOverlayComponentParams}
      />
    </div>
  );
};